import { useDrop } from 'react-dnd'
import { useGame } from '../contexts/GameContext'
import type { Bin, Trash } from '../interfaces/GameScreen'

const TrashBin = (bin: Bin) => {
	const { handleDrop, handleBinClick } = useGame()

	const [{ isOver }, drop] = useDrop({
		accept: 'trash',
		drop: (item: Trash) => handleDrop(item, bin.id),
		collect: (monitor) => ({
			isOver: !!monitor.isOver(),
		}),
	})

	const getBinImage = (type: string) => {
		const binImages = {
			yellow: './assets/lixeiras/lixo_metal.svg',
			brown: './assets/lixeiras/lixo_organico.svg',
			blue: './assets/lixeiras/lixo_papel.svg',
			red: './assets/lixeiras/lixo_plastico.svg',
			green: './assets/lixeiras/lixo_vidro.svg',
		}
		return binImages[type as keyof typeof binImages]
	}

	return (
		<div
			ref={drop}
			className={`cursor-pointer transition-all duration-200 ${
				isOver ? 'scale-110 brightness-110' : ''
			}`}
			onClick={() => handleBinClick(bin.id)}
		>
			<img
				src={getBinImage(bin.id)}
				alt={`Lixeira ${bin.id}`}
				className="w-10 object-contain lg:h-20 lg:w-16"
				draggable={false}
			/>
		</div>
	)
}

export default TrashBin
